import type { IconName } from '../components/Icon';

export interface WorkspaceLink { to: string; label: string; icon: IconName; paths: string[] }
export interface WorkspaceSection extends WorkspaceLink { links: WorkspaceLink[] }

/** Canonical destinations and retained aliases share one navigation location. */
export const workspaceNavigation: WorkspaceSection[] = [
  { to: '/', label: 'Today', icon: 'home', paths: ['/', '/metrics'], links: [
    { to: '/', label: 'Today', icon: 'home', paths: ['/'] },
    { to: '/metrics', label: 'Metrics', icon: 'metrics', paths: ['/metrics'] }
  ] },
  { to: '/crm', label: 'Relationships', icon: 'relationships', paths: ['/crm', '/relationships', '/prospects', '/previews'], links: [
    { to: '/crm', label: 'Relationships', icon: 'relationships', paths: ['/crm', '/relationships'] },
    { to: '/prospects', label: 'Prospects / outreach', icon: 'search', paths: ['/prospects'] },
    { to: '/previews', label: 'Preview gallery', icon: 'smartphone', paths: ['/previews'] }
  ] },
  { to: '/campaigns', label: 'Campaigns', icon: 'campaign', paths: ['/campaigns'], links: [] },
  { to: '/content', label: 'Publishing', icon: 'content', paths: ['/content', '/publishing', '/emails'], links: [
    { to: '/content', label: 'Website content', icon: 'content', paths: ['/content', '/publishing'] },
    { to: '/emails', label: 'Support inbox', icon: 'reply', paths: ['/emails'] }
  ] },
  { to: '/audit', label: 'Activity', icon: 'clock', paths: ['/audit', '/activity', '/runs', '/work', '/reports', '/backlog', '/experiments'], links: [
    { to: '/audit', label: 'Activity', icon: 'clock', paths: ['/audit', '/activity'] },
    { to: '/work', label: 'Team work', icon: 'backlog', paths: ['/work'] },
    { to: '/runs', label: 'Agents / runs', icon: 'runs', paths: ['/runs'] },
    { to: '/reports', label: 'Reports', icon: 'reports', paths: ['/reports'] },
    { to: '/experiments', label: 'Experiments', icon: 'experiments', paths: ['/experiments'] },
    { to: '/backlog', label: 'Backlog', icon: 'backlog', paths: ['/backlog'] }
  ] }
];

export function workspaceSection(pathname: string, search = ''): WorkspaceSection | undefined {
  if (['/crm', '/relationships'].includes(pathname) && new URLSearchParams(search).get('view') === 'campaigns')
    return workspaceNavigation.find(item => item.to === '/campaigns');
  return workspaceNavigation.find(item => item.paths.includes(pathname));
}

export const SCHEDULE_PATH = '/runs?panel=schedule';
